// src/common/components/cartModal/components/orderSuccessStage/OrderSuccessStage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  MdCheckCircle,
  MdClose,
  MdError,
  MdHistory,
  MdHome,
} from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./OrderSuccessStage.module.scss";
import { ROUTES } from "../../../../utils/constants";
import Button from "../../../button/Button";

interface OrderSuccessStageProps {
  onClose: () => void;
  orderNumber?: number | null;
  paymentFailed?: boolean;
  paymentError?: string;
}

export default function OrderSuccessStage({
  onClose,
  orderNumber,
  paymentFailed,
  paymentError,
}: OrderSuccessStageProps) {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleViewOrderHistory = () => {
    onClose();
    navigate(ROUTES.ORDERS);
  };

  const handleGoToMain = () => {
    onClose();
    navigate(ROUTES.MAIN);
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <div
        className={styles.header}
        style={{ borderBottomColor: theme.border }}
      >
        <button className={styles.backButton} onClick={onClose}>
          <MdClose size={24} color={theme.text} />
        </button>
        <div className={styles.titleContainer}>
          <h2 className={styles.title} style={{ color: theme.text }}>
            Заказ оформлен
          </h2>
          <p className={styles.subtitle} style={{ color: theme.textSecondary }}>
            {paymentFailed ? "Требуется оплата" : "Спасибо за заказ"}
          </p>
        </div>
      </div>

      <div className={styles.content}>
        {paymentFailed ? (
          <MdError
            size={80}
            color={theme.danger}
            className={styles.successIcon}
          />
        ) : (
          <MdCheckCircle
            size={80}
            color={theme.success}
            className={styles.successIcon}
          />
        )}

        <h3 className={styles.successTitle} style={{ color: theme.text }}>
          Заказ оформлен
        </h3>
        <p
          className={styles.successText}
          style={{ color: theme.textSecondary }}
        >
          {paymentFailed
            ? paymentError ||
              "Оплата не прошла. Вы можете оплатить заказ позже из списка заказов."
            : "Спасибо за заказ"}
        </p>

        {orderNumber && (
          <>
            <p
              className={styles.successText}
              style={{ color: theme.textSecondary }}
            >
              Номер заказа
            </p>
            <p className={styles.orderNumber} style={{ color: theme.primary }}>
              #{orderNumber}
            </p>
          </>
        )}

        {!paymentFailed && (
          <p
            className={styles.successText}
            style={{ color: theme.textSecondary }}
          >
            Мы свяжемся с вами для подтверждения заказа
          </p>
        )}

        <div className={styles.buttonsContainer}>
          <Button
            title="Посмотреть историю заказов"
            onClick={handleViewOrderHistory}
            variant="primary"
            className={styles.actionButton}
            icon={<MdHistory size={20} />}
            fullWidth
          />

          <Button
            title="Вернуться на главную"
            onClick={handleGoToMain}
            variant="secondary"
            className={styles.actionButton}
            icon={<MdHome size={20} />}
            fullWidth
          />

          <Button
            title="Закрыть"
            onClick={onClose}
            variant="outline"
            className={styles.actionButton}
            icon={<MdClose size={20} />}
            fullWidth
          />
        </div>
      </div>
    </div>
  );
}
